<template>
  <div class="login-container">
    <div class="login-box">
      <img src="../assets/logo.png" class="logo" />

      <div class="login-tabs">
        <button :class="{ active: mode === 'password' }" @click="mode = 'password'">账号密码</button>
        <button :class="{ active: mode === 'dingtalk' }" @click="switchToDingTalk">钉钉扫码</button>
      </div>

      <form v-if="mode === 'password'" class="form" @submit.prevent="login">
        <div class="input-box">
          <i class="el-icon-user icon"></i>
          <input v-model.trim="username" placeholder="用户名" autocomplete="username" />
        </div>

        <div class="input-box">
          <i class="el-icon-lock icon"></i>
          <input
            v-model="password"
            type="password"
            placeholder="密码"
            autocomplete="current-password"
          />
        </div>

        <button class="login-btn" type="submit" :disabled="loading">
          {{ loading ? "登录中..." : "登录" }}
        </button>

        <div class="form-actions">
          <button type="button" class="link-btn" @click="$router.push('/forgot-password')">
            忘记密码？
          </button>
        </div>
      </form>

      <div v-else class="ding-login">
        <div v-if="dingLoading" class="ding-state"><i class="el-icon-loading"></i> 正在生成二维码...</div>
        <template v-else-if="dingInfo">
          <img v-if="!isMobile" :src="dingInfo.qrImageUrl" class="ding-qr" alt="钉钉登录二维码" />
          <p class="ding-tip">{{ isMobile ? "请在钉钉中完成授权登录" : "请使用钉钉扫码登录" }}</p>
          <button v-if="isMobile" class="login-btn" type="button" @click="openDingTalk">打开钉钉授权</button>
          <button v-else class="refresh-btn" type="button" @click="loadDingTalk">刷新二维码</button>
        </template>
        <div v-else class="ding-state">钉钉扫码登录暂不可用</div>
      </div>
    </div>
  </div>
</template>

<script>
import request, { parseApiError, parseApiResponse } from "@/utils/request"

export default {
  name: "LoginPage",
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      mode: "password",
      dingLoading: false,
      dingInfo: null,
      dingPollTimer: null,
      isMobile: /Android|iPhone|iPad|Mobile/i.test(navigator.userAgent)
    }
  },
  created() {
    const error = this.$route.query.dingtalkError
    if (error) this.$message.error(String(error))
    const ticket = this.$route.query.dingtalkTicket
    if (ticket) this.exchangeDingTalk(String(ticket))
  },
  beforeDestroy() {
    this.stopDingTalkPolling()
  },
  methods: {
    switchToDingTalk() {
      this.mode = "dingtalk"
      if (!this.dingInfo) this.loadDingTalk()
    },
    loadDingTalk() {
      this.stopDingTalkPolling()
      this.dingLoading = true
      this.dingInfo = null
      const redirect = typeof this.$route.query.redirect === "string" ? this.$route.query.redirect : "/portal"
      request.get("/api/login/dingtalk/start", { params: { redirect } }).then(res => {
        this.dingInfo = parseApiResponse(res, "生成钉钉二维码失败")
        this.startDingTalkPolling()
      }).catch(err => {
        this.$message.error(parseApiError(err, "钉钉扫码登录尚未配置"))
      }).finally(() => { this.dingLoading = false })
    },
    openDingTalk() {
      if (this.dingInfo && this.dingInfo.loginUrl) window.location.href = this.dingInfo.loginUrl
    },
    startDingTalkPolling() {
      if (!this.dingInfo || !this.dingInfo.state) return
      this.dingPollTimer = window.setInterval(() => {
        request.get("/api/login/dingtalk/status", { params: { state: this.dingInfo.state } }).then(res => {
          const data = parseApiResponse(res, "查询扫码状态失败")
          if (data.status === "CONFIRMED" && data.ticket) {
            this.stopDingTalkPolling()
            this.$message.success("手机确认成功，正在登录...")
            this.exchangeDingTalk(data.ticket)
          } else if (data.status === "EXPIRED") {
            this.stopDingTalkPolling()
            this.$message.warning("二维码已过期，请刷新二维码")
          }
        }).catch(() => {
          // 临时网络波动时继续轮询，二维码有效期到期后由服务端返回 EXPIRED。
        })
      }, 2000)
    },
    stopDingTalkPolling() {
      if (this.dingPollTimer) window.clearInterval(this.dingPollTimer)
      this.dingPollTimer = null
    },
    exchangeDingTalk(ticket) {
      this.loading = true
      this.mode = "dingtalk"
      request.post("/api/login/dingtalk/exchange", { ticket }).then(res => {
        const data = parseApiResponse(res, "钉钉登录失败")
        localStorage.setItem("token", data.token)
        this.$router.replace(data.redirect && data.redirect.startsWith("/") ? data.redirect : "/portal")
      }).catch(err => {
        this.$message.error(parseApiError(err, "钉钉登录票据已失效，请重新扫码"))
        this.loadDingTalk()
      }).finally(() => { this.loading = false })
    },
    login() {
      if (!this.username || !this.password) {
        this.$message.warning("请输入用户名和密码")
        return
      }
      this.loading = true
      request.post("/api/login", {
        userId: this.username,
        password: this.password
      }).then(res => {
        const data = parseApiResponse(res, "登录失败");
        localStorage.setItem("token", data.token)
        const redirect = this.$route.query.redirect
        this.$router.push(typeof redirect === "string" && redirect.startsWith("/") ? redirect : "/portal")
      }).catch(err => {
        console.error(err)
        this.$message.error(parseApiError(err, "系统异常，请稍后再试"))
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  background: url("../assets/login-bg.jpg");
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  width: 420px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.18);
}

.logo {
  width: 220px;
  margin-bottom: 30px;
}

.login-tabs { display: flex; margin: -8px 0 24px; border-bottom: 1px solid #e5e7eb; }
.login-tabs button { flex: 1; padding: 10px; border: 0; border-bottom: 2px solid transparent; background: transparent; color: #64748b; cursor: pointer; }
.login-tabs button.active { color: #2d6cdf; border-bottom-color: #2d6cdf; font-weight: 600; }
.ding-login { min-height: 258px; display: flex; flex-direction: column; align-items: center; justify-content: center; }
.ding-qr { width: 220px; height: 220px; border: 1px solid #e5e7eb; border-radius: 6px; }
.ding-tip, .ding-state { color: #64748b; margin: 14px 0; }
.refresh-btn { border: 0; background: transparent; color: #2d6cdf; cursor: pointer; }

.input-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  background: #f5f7fb;
  border: 1px solid #e4e8f0;
  border-radius: 6px;
  padding: 10px 12px;
}

.icon {
  margin-right: 10px;
  color: #64748b;
}

input {
  border: none;
  outline: none;
  background: none;
  flex: 1;
  min-width: 0;
  color: #1f2937;
}

.login-btn {
  width: 100%;
  height: 40px;
  background: #2d6cdf;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
}

.login-btn:hover {
  background: #1f57b3;
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}

.link-btn {
  border: none;
  background: transparent;
  color: #2d6cdf;
  cursor: pointer;
  padding: 0;
  font-size: 14px;
}
</style>
